import React, { useEffect } from 'react'
import './avisoPrivacidad.css'

function avisoPrivacidad () {
  useEffect(() => {
    document.title = 'Aviso de Privacidad' || ' '
  }, [])
  return (
    <div className='site-inner'>
      <main className='content'>
        <article className='aviso'>
          <header className='header'>
            <h1 className='titleAviso'>Aviso de privacidad</h1>
          </header>
          <div className='entry-content'>
            <div>
              <div className='fl-row'>
                <div className='fl-wrap'>
                  <div className='separador'></div>
                  <div className='fl-row-content'>
                    <div className='fl-col-group'>
                      <div className='fl-col'>
                        <div className='fl-col-content'>
                          <div className='fl-module'>
                            <div className='fl-module-content'>
                              <div className='fl-rich-text'>
                                <div className='mk-text-block'>
                                  <h3 className='puntoPriv'>
                                    Responsable del tratamiento de sus datos personales.
                                  </h3>

                                  <p className='descripcion'>
                                    De conformidad con la Ley Federal de Protección de Datos Personales en
                                    Posesión de los Particulares (en lo sucesivo la Ley), METAL MECÁNICA
                                    MACON, S.A. DE C.V. e INDUSTRIAS MACON, S.A DE C.V. (ambas en lo sucesivo
                                    MACON) con domicilio para efectos del presente Aviso de Privacidad el
                                    ubicado en Canatlán 370, Gómez Palacio, Durango. Col. Parque Industrial
                                    Lagunero C.P. 35078 y medios digitales de contacto como páginas web:
                                    www.frikko.com, www.heatwave.com.mx, www.imacon.com y/o la dirección de
                                    correo electrónico frikko@plexiz.com (en lo sucesivo los Sitios Web de
                                    MACON); informa a la persona física con quien MACON establezca una relación
                                    contractual o comercial o que derivado de lo anterior, ingresen y transiten
                                    en los Sitios Web de MACON (en lo sucesivo el USUARIO) que MACON tiene la
                                    convicción de proteger y respetar los datos personales que el USUARIO
                                    proporcione o haya proporcionado a MACON.
                                  </p>

                                  <p className='descripcion'>
                                    Al entablar una relación contractual o comercial con MACON, mediante
                                    cualquiera de las formas establecidas en las Leyes Mexicanas y/o al
                                    ingresar, utilizar o transitar en los Sitios Web de MACON, el USUARIO
                                    manifiesta tácitamente su consentimiento respecto a los términos del
                                    presente Aviso de Privacidad.
                                  </p>

                                  <p className='descripcion'>
                                    En términos de lo dispuesto por el artículo 8 de la Ley se entenderá que
                                    usted consiente tácitamente el tratamiento de sus datos cuando,
                                    habiéndose puesto a su disposición el presente Aviso de Privacidad, no
                                    manifieste su oposición.
                                  </p>

                                  <ul className='ulPrincipal'>
                                    <li>
                                      <h3 className='puntoPriv'>Datos Personales que se recaban.</h3>

                                      <p className='descripcion'>
                                        MACON podrá recabar y, en su caso, tratar los datos personales que a
                                        continuación se especifican...
                                      </p>

                                      <p className='descripcion'>
                                        Podrán recabarse y tratarse otros datos personales que no se incluyan
                                        en las listas anteriores siempre y cuando dichos datos se consideren de
                                        la misma naturaleza y guarden relación respecto a las finalidades para
                                        los cuales se obtienen.
                                      </p>
                                    </li>

                                    <li>
                                      <h3 className='puntoPriv'>
                                        Finalidades y/o Usos de los datos personales.
                                      </h3>

                                      <p className='descripcion'>
                                        MACON recaba, utiliza, almacena, transmite o transfiere sus datos
                                        personales, en la medida en que la Ley lo permite.
                                      </p>

                                      <p className='descripcion'>
                                        <strong>Finalidades primarias:</strong> Gestionar solicitudes de
                                        cotizaciones comerciales, operaciones de compra-venta, atención de
                                        pólizas de garantías e instalaciones.
                                      </p>

                                      <p className='descripcion'>
                                        <strong>Finalidades secundarias:</strong> Envío de promociones
                                        comerciales, publicidad, así como para el envío de información respecto
                                        de nuestros productos y servicios.
                                      </p>

                                      <p className='descripcion'>
                                        Si usted desea que sus datos personales no sean tratados para las
                                        finalidades secundarias podrá manifestarlo enviando un correo a
                                        frikko@plexiz.com.
                                      </p>

                                      <p className='descripcion'>
                                        MACON conservará los datos personales únicamente durante el tiempo que
                                        resulte necesario para cumplir con las finalidades descritas.
                                      </p>

                                      <p className='descripcion'>
                                        MACON podrá transferir los datos personales a terceros cuando resulte
                                        necesario para el cumplimiento de las finalidades antes descritas.
                                      </p>

                                      <p className='descripcion'>
                                        Parte o toda la atención podrá ser asistida por sistemas de
                                        inteligencia artificial como herramienta de apoyo para el cumplimiento
                                        de las finalidades descritas en este Aviso de Privacidad.
                                      </p>
                                    </li>

                                    <li>
                                      <h3 className='puntoPriv'>
                                        Seguridad de los datos personales y transferencias.
                                      </h3>

                                      <p className='descripcion'>
                                        Con fundamento en los artículos 13, 14 y 15 de la Ley, MACON podrá
                                        transferir datos personales a terceros cuando sea necesario para el
                                        cumplimiento de las finalidades establecidas.
                                      </p>

                                      <p className='descripcion'>
                                        Las transferencias podrán realizarse dentro de México o al extranjero
                                        hacia proveedores de servicios tecnológicos, de mensajería, asesores
                                        externos, instituciones financieras, empresas afiliadas o autoridades
                                        competentes.
                                      </p>

                                      <p className='descripcion'>
                                        MACON se compromete a guardar estricta confidencialidad de sus datos
                                        personales y ha adoptado medidas de seguridad legales, técnicas,
                                        físicas y administrativas.
                                      </p>

                                      <p className='descripcion'>
                                        Nuestros sitios web pueden utilizar cookies, web beacons y tecnologías
                                        similares para analizar el uso de navegación y mejorar la experiencia
                                        del usuario.
                                      </p>
                                    </li>

                                    <li>
                                      <h3 className='puntoPriv'>
                                        Derechos que le corresponden al USUARIO respecto a sus datos
                                        personales.
                                      </h3>

                                      <p className='descripcion'>
                                        Usted podrá ejercer los derechos ARCO mediante correo electrónico a
                                        frikko@plexiz.com.
                                      </p>

                                      <ul className='ulAviso'>
                                        <li>Nombre completo del titular.</li>
                                        <li>Domicilio.</li>
                                        <li>Teléfono.</li>
                                        <li>Correo electrónico usado en los sitios web.</li>
                                        <li>Copia de una identificación oficial adjunta.</li>
                                        <li>Asunto «Derechos ARCO».</li>
                                      </ul>

                                      <p className='descripcion'>
                                        MACON emitirá una respuesta a su solicitud en un plazo de 20 días
                                        hábiles contados a partir de la fecha en que reciba ésta.
                                      </p>

                                      <p className='descripcion'>
                                        Le informamos que, ante la negativa de respuesta o inconformidad con la
                                        misma, usted puede presentar ante Transparencia para el Pueblo,
                                        adscrito a la Secretaría Anticorrupción y Buen Gobierno, la
                                        correspondiente Solicitud de Protección de Derechos.
                                      </p>
                                    </li>

                                    <li>
                                      <h3 className='puntoPriv'>Cambios al aviso de privacidad.</h3>

                                      <p className='descripcion'>
                                        MACON se reserva el derecho a modificar o actualizar en cualquier
                                        momento el contenido del presente Aviso de Privacidad, mismos que
                                        podrán ser informados mediante nuestras páginas web
                                        www.frikko.com, www.heatwave.com.mx y www.imacon.com.
                                      </p>
                                    </li>
                                  </ul>

                                  <div className='separador-privacidad'>
                                    <span className='linea-privacidad'></span>
                                  </div>

                                  <h2 className='tituloPequeño'>
                                    Última actualización de este aviso de privacidad: 17 de Julio del 2026
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
    </div>
  )
}

export default avisoPrivacidad
